// @flow
export default function assert(condition: any, message: string) {
    console.assert(condition, message);
    if (!condition) {
        throw Error(message);
    }
}
